<template>
    <div>
        <v-btn fab dark small color="primary" @click="mostrar=true">
            <v-icon dark>add</v-icon>
        </v-btn>



        <v-dialog v-model="mostrar" persistent max-width="700">
            <v-card>
                <v-card-title class="headline">Agregar asistencia manual</v-card-title>
                <v-card-text>
                    <v-container grid-list-md>
                        <v-layout row wrap>
                            <v-flex xs12 md12>
                    
                                <v-autocomplete
                                    v-model="empleado"
                                    :items="empleados"
                                    label="Empleado"
                                    return-object
                                    item-value="_id"
                                    item-text="nombre"
                                >
                                    <template v-slot:selection="data">
                                        {{data.item.codigo}} - {{data.item.nombre}}
                                    </template>
                                    <template v-slot:item="data">
                                        {{data.item.codigo}} - {{data.item.nombre}}
                                </template>
                                </v-autocomplete>
                            </v-flex>

                            <v-flex xs12 sm6 md4>
                                <v-menu
                                    v-model="fechaCal"
                                    :close-on-content-click="false"
                                    full-width
                                    max-width="290"
                                    >
                                    <v-text-field
                                        :value="fechaTxt"
                                        label="Fecha"
                                        slot="activator"
                                        readonly
                                    ></v-text-field>
                                    <v-date-picker
                                        v-model="fecha"
                                        @change="fechaCal = false"
                                        locale="es"
                                        reactive
                                    ></v-date-picker>
                                </v-menu>
                            </v-flex>

                            <v-flex xs12 sm6 md4>
                                <v-select
                                    v-model="entrada"
                                    :items="entradaSel"
                                ></v-select>
                            </v-flex>

                            <v-flex xs12 sm6 md4>
                                <v-menu
                                    v-model="horaSel"
                                    :close-on-content-click="false"
                                    lazy
                                    transition="scale-transition"
                                    offset-y
                                    full-width
                                    max-width="290px"
                                    min-width="290px"
                                >
                                    <template v-slot:activator="{ on }">
                                    <v-text-field
                                        v-model="hora"
                                        label="Hora"
                                        readonly
                                        v-on="on"
                                    ></v-text-field>
                                    </template>
                                    <v-time-picker
                                        v-if="horaSel"
                                        v-model="hora"
                                        format="24hr"
                                        @change="fechaCal = false"
                                        full-width
                                    ></v-time-picker>
                                </v-menu>
                            </v-flex>

                            <v-flex xs12 sm12 md12>
                                <v-textarea
                                    label="Observaciones"
                                    v-model="observaciones"
                                    rows="5"
                                ></v-textarea>
                            </v-flex>

                        </v-layout>
                    </v-container>
                    
                </v-card-text>
                <v-card-actions>
                <v-spacer></v-spacer>
                <v-btn color="primary" small @click="agregarAsistencia()">Agregar</v-btn>
                <v-btn color="normal" small @click="mostrar = false">Cancelar</v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>



    </div>
</template>

<script>
import { mapGetters } from "vuex";
import axios from 'axios'
import moment from 'moment-timezone'
moment.locale('es');

export default {
    name: 'Agregar',
    props:['empleados'],
    computed: {
        ...mapGetters([
            "sessionToken",
            "httpURL",
            "userId",
            "tableProps",
            "role",
            "permisos"
        ]),
        fechaTxt(){
            return moment(this.fecha).format('DD [de] MMMM [de] YYYY')
        }
    },
    created(){
        this.empleados.forEach(element => {
            this.empleadoSel.push({value:element._id,text:element.codigo+' - '+element.nombre})
        });
    },
    data() {
        return {
            mostrar:false,
            empleadoSel:[],
            empleado: null,
            fechaCal:false,
            fecha: moment().format('YYYY-MM-DD'),
            entradaSel:[
                {value:true, text:'Entrada'},
                {value:false, text:'Salida'}
            ],
            entrada:true,
            horaSel: false,
            hora: '08:00',
            observaciones:null
        }
    },
    methods:{
        enviandoStart(){
            this.$emit('enviandoStart');
        },
        enviandoStop(){
            this.$emit('enviandoStop');
        },
        agregarAsistencia(){
            this.enviandoStart();
            if( this.empleado ){
                axios.post(this.httpURL+'/asistencias/usuario/'+this.empleado._id,
                    {fecha:this.fecha,hora:this.hora,entrada:this.entrada,observaciones:this.observaciones},
                    {headers:{token: this.sessionToken}})
                    .then(res => {
                        // console.log(res);
                        // this.calculos = res.data.calculos;
                        this.enviandoStop();
                        this.mostrar = false;
                        this.$notify({ group: 'foo_notif', type:'success', duration:3500, text: res.data.mensaje});
                    })
                    .catch(error => {
                        // console.log(error);
                        this.enviandoStop();
                        this.$notify({ group: 'foo_notif', type:'error', duration:4000, text: error.response.data.mensaje});
                    });
            }
        }

    }
}
</script>